export const EDIT_PROFILE = "EDIT_PROFILE"
export const PROFILE_SUCCESS = "PROFILE_SUCCESS"
export const PROFILE_ERROR = "PROFILE_ERROR"

export const EDIT_MODE = "EDIT_MODE"
export const EDIT_MODE_SUCCESS = "EDIT_MODE_SUCCESS"
export const EDIT_MODE_ERROR = "EDIT_MODE_ERROR"

export const EDIT_PHOTO = "EDIT_PHOTO"
export const EDIT_PHOTO_SUCCESS = "EDIT_PHOTO_SUCCESS"
export const EDIT_PHOTO_FAIL = "EDIT_PHOTO_FAIL"

export const EDIT_PASSWORD = "EDIT_PASSWORD"
export const EDIT_PASSWORD_SUCCESS = "EDIT_PASSWORD_SUCCESS"
export const EDIT_PASSWORD_FAIL = "EDIT_PASSWORD_FAIL"

export const EDIT_IMPORTANT_ORDER = "EDIT_IMPORTANT_ORDER"

export const SHOW_LOADING = "SHOW_LOADING"
export const HIDE_LOADING = "HIDE_LOADING"
